import styled from 'styled-components';
import IMG_NOTICE_MOCK from '@/assets/book/img_notice_mock.png';
import { Icon } from '@successmode-ktp/kui';
import IMG_CONFETTI from '@/assets/book/img_confetti.png';

function Banner() {
  return (
    <Wrapper
      href='https://docs.google.com/forms/d/e/1FAIpQLSf5S1acJePmODXIjs_im0jFT9QJ5tqKbX_JKsmbGRszIK40wQ/viewform?usp=header'
      target='_blank'
    >
      <LeftSection>
        <img src={IMG_NOTICE_MOCK} alt='' height={86} />
        <Text>
          <Title>글로벌 환자 예약 서비스 출시</Title>
          <Desc>
            우리 병원의 글로벌 고객 연결, KTP와 함께 지금 무료로 시작해보세요
          </Desc>
        </Text>
      </LeftSection>
      <RightSection>
        <LinkButton
          style={{
            backgroundColor: '#0057FF',
            width: '136px',
            borderRadius: '8px',
            fontSize: '14px',
            gap: '2px',
          }}
        >
          서비스 신청하기
          <Icon.ChevronRight size={16} fillColor='#fff' />
        </LinkButton>
      </RightSection>
    </Wrapper>
  );
}

const Wrapper = styled.a`
  position: relative;
  width: 100%;
  height: 86px;
  padding: 0 36px 0 18px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #fff 1.04%, #6fd8fc 50.43%);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 227px;
    height: 227px;
    top: -20px;
    left: -130px;
    border-radius: 500px;
    background: radial-gradient(
      68.63% 68.63% at 31.03% 53.74%,
      #cef2fe 0%,
      #fff 100%
    );
    z-index: 0;
  }

  &::after {
    content: '';
    width: 640px;
    height: 500px;
    position: absolute;
    top: -50px;
    right: 0;
    background-image: url(${IMG_CONFETTI});
    background-size: 100% 100%;
    z-index: 0;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 2;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const Title = styled.strong`
  color: #5089f8;
  font-size: 20px;
  font-weight: 800;
  line-height: 30px;
`;

const Desc = styled.p`
  color: #3a3b3e;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
`;

const RightSection = styled.div`
  z-index: 2;
`;

const LinkButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 0 16px;
  width: 140px;
  height: 42px;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  white-space: nowrap;
`;

export default Banner;
